import { render, staticRenderFns } from "./UnarchiveFolderDialog.vue?vue&type=template&id=79492b11&scoped=true"
import script from "./UnarchiveFolderDialog.vue?vue&type=script&lang=js"
export * from "./UnarchiveFolderDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79492b11",
  null
  
)

export default component.exports